module.exports = __webpack_public_path__ + "static/media/mountains_behind_day.def5cad6.png";